// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__21fpw","empty":"ModalGraph_empty__2yw6A"};